// Selection helpers: the selection is a list of top node ids (layer children). Bounds are geometric
// (outline, without stroke), like Illustrator's default.
import type { DisplayList } from '../render/displayList';
import type { Rect } from '../model/types';
import { unionRect } from '../geometry/mat';

export function selectionBounds(list: DisplayList, ids: string[]): Rect | null {
  if (!ids.length) return null;
  const set = new Set(ids);
  let r: Rect | null = null;
  for (const it of list.items) if (set.has(it.topId) && !it.hidden) r = unionRect(r, it.gbounds);
  return r;
}

/** Handles of a bounds box in screen space: 0..7 = nw, n, ne, e, se, s, sw, w. */
export function handlePoints(r: Rect): [number, number][] {
  const { x, y, w, h } = r;
  return [
    [x, y],
    [x + w / 2, y],
    [x + w, y],
    [x + w, y + h / 2],
    [x + w, y + h],
    [x + w / 2, y + h],
    [x, y + h],
    [x, y + h / 2],
  ];
}
/** The handle opposite to handle `i` (the fixed point while scaling). */
export const opposite = (i: number) => (i + 4) % 8;
